import './getStartedPage.styles.scss';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button } from '@material-ui/core';

import DocTitleScrollTop from '../../utils/DocTitleScrollTop';

import starsPatternImg from '../../assets/imgs/bkgs/star-pattern.svg';
import earthImg from '../../assets/imgs/bkgs/earth-two-rings.svg';
import { ForwardRounded } from '@material-ui/icons';

const GetStartedPage = () => {
	// useEffect(() => {
	// 	window.scrollTo(0, 0);
	// 	document.title = 'Get Started';
	// }, []);
	DocTitleScrollTop('Get Started');
	return (
		<div
			className="homepage"
			style={{ backgroundImage: `url(${starsPatternImg})` }}
		>
			<div className="mfaContainer homepageContent">
				<div className="imgDiv">
					<img src={earthImg} alt="img" />
				</div>

				<div className="textDiv">
					<h1>Socialize, and grow your network for free.</h1>
					<Button
						color="primary"
						variant="contained"
						component={RouterLink}
						to="/home"
					>
						Get Started
						<ForwardRounded color="inherit" />
					</Button>
				</div>
			</div>
		</div>
	);
};

export default GetStartedPage;
